function getLocale() {
  return JSON.parse(
    window.productTranslations
      .replaceAll("&quot;", '"')
      .replaceAll("&gt;", ">")
      .replaceAll("=>", ":")
  );
}

function addToCart(data, button) {
  button.childNodes[0].childNodes.forEach((child) => {
    if (!child.classList?.contains?.("loading__spinner")) {
      child.classList?.add?.("hidden");
    }
  });

  button.disabled = true;
  button.querySelector(".loading__spinner").classList.remove("hidden");

  document.addEventListener('cart:refresh:end', () => {
    const closeCartButton = document.querySelector(
      ".cart-drawer__header .drawer__close-btn"
    );

    if (closeCartButton) {
      closeCartButton.addEventListener("click", () => {
        const cartDrawer = document.querySelector("#CartDrawer");
        cartDrawer.removeAttribute?.("open");
      });

      button.childNodes[0].childNodes.forEach((child) => {
        if (!child.classList?.contains?.("loading__spinner")) {
          child.classList?.remove?.("hidden");
        }
      });

      button.disabled = false;
      button.querySelector(".loading__spinner").classList.add("hidden");
    }
  });

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then(() => {
    fetch("/cart.js").then((res) => {
      res.json().then((cart) => {
        document.dispatchEvent(
          new CustomEvent("cart:refresh", {
            detail: {
              open: true,
            },
          })
        );

        cart.sections = {};

        setTimeout(() => {
          window.FoxTheme.pubsub.publish(
            window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            {
              cart,
            }
          );
        }, 500);
      });
    });
  });
}

let cartDrawerProductsRecommendationSlider = null;

async function overrideCartDrawerProductsRecommendation() {
  const mutationObserver = new MutationObserver(async (_, observer) => {

    const cartDrawerProductsRecommendation = document?.querySelector(
      ".cart-drawer-products-recommendation"
    );

    if (!cartDrawerProductsRecommendation) return;

    const cartDrawerProductsRecommendationSwiperWrapper =
      cartDrawerProductsRecommendation?.querySelector(".swiper-wrapper");

    if (!cartDrawerProductsRecommendationSwiperWrapper) return;

    cartDrawerProductsRecommendation?.classList?.add("swiper-horizontal-override");

    if (cartDrawerProductsRecommendationSlider) {
      clearInterval(cartDrawerProductsRecommendationSlider);
    }

    cartDrawerProductsRecommendationSlider = setInterval(() => {
      const slider = document.querySelector("cart-drawer-products-recommendation")
        ?.carousel?.slider;

      if (slider) {
        if (!slider.isEnd) {
          slider.slideNext();
        } else {
          slider.slideTo?.(0);
        }
      }
    }, 5000);

    const locale = getLocale();
    const titles = document.querySelectorAll(".product-card__title a");

    // ── Recommendation slides (have pr_rec_pid) → replace with Add to basket ──
    const recommendationShopButtons = Array.from(
      cartDrawerProductsRecommendationSwiperWrapper.querySelectorAll(
        ".product-card__list-actions a"
      )
    ).filter(btn => new URL(btn.href).searchParams.has("pr_rec_pid"));

    for (const shopButton of recommendationShopButtons) {
      const productId = new URL(shopButton.href).searchParams.get("pr_rec_pid");
      const productTitle = Array.from(titles).find(title => title.href.includes(productId));
      const handle = new URL(productTitle.href).pathname;
      const product = await fetch(`${handle}.json`);
      const productData = await product.json();
      const firstVariant = productData.product?.variants?.[0];

      const button = document.createElement("button");
      button.setAttribute("data-product-id", productId);
      button.classList.add("color-scheme-inverse");
      button.innerHTML = `<span class="btn__text product__block--complementary__add-to-cart-upsell-button">
        <img src="${window.assets.iconPlus}" class="icon icon--small" alt="">
        <span class="btn__text">${locale.product.add_to_cart_short}</span>
        <svg aria-hidden="true" focusable="false" class="spinner icon icon--medium loading__spinner hidden"
          viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"
          style="stroke: rgb(var(--color-foreground));">
          <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
        </svg>
      </span>`;

      button.addEventListener("click", (e) => {
        e.preventDefault();

        let complementaryProduct = window.complementaryProducts?.find?.(
          (product) => product.id === Number(productId)
        );

        if (!complementaryProduct) {
          const complementaryProductsIds = window.complementaryProductsIds;
          const complementaryProductId = complementaryProductsIds.find(
            (id) => id === Number(productId)
          );
          const variantIndex = complementaryProductsIds.indexOf(complementaryProductId);
          complementaryProduct = {
            variants: [{ id: window.complementaryVariantsIds[variantIndex] }],
          };
        }

        if (complementaryProduct) {
          addToCart({
            items: [{
              id: complementaryProduct.variants[0].id || firstVariant?.id,
              quantity: 1,
            }],
          }, button);
        }
      });

      shopButton.replaceWith(button);
    }

    // ── Injected custom product (no pr_rec_pid) → Add to basket via product JSON ──
    const injectedShopButtons = Array.from(
      cartDrawerProductsRecommendationSwiperWrapper.querySelectorAll(
        ".product-card__list-actions a"
      )
    ).filter(btn => !new URL(btn.href).searchParams.has("pr_rec_pid"));

    for (const shopButton of injectedShopButtons) {
      const handle = new URL(shopButton.href).pathname;
      const product = await fetch(`${handle}.json`);
      const productData = await product.json();
      const firstVariant = productData.product?.variants?.[0];

      if (!firstVariant) continue;

      const button = document.createElement("button");
      button.setAttribute("data-product-id", String(productData.product.id));
      button.classList.add("color-scheme-inverse");
      button.innerHTML = `<span class="btn__text product__block--complementary__add-to-cart-upsell-button">
        <img src="${window.assets.iconPlus}" class="icon icon--small" alt="">
        <span class="btn__text">${locale.product.add_to_cart_short}</span>
        <svg aria-hidden="true" focusable="false" class="spinner icon icon--medium loading__spinner hidden"
          viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"
          style="stroke: rgb(var(--color-foreground));">
          <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
        </svg>
      </span>`;

      button.addEventListener("click", (e) => {
        e.preventDefault();
        addToCart({
          items: [{ id: firstVariant.id, quantity: 1 }],
        }, button);
      });

      shopButton.replaceWith(button);
    }

    observer.disconnect();
  }).observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function overrideUpsellCarousel() {
  const swiper = document.querySelector(".product__block--complementary");
  const swiperWrapper = swiper.querySelector(".swiper-wrapper");
  const complementaryProductsContainer = document.querySelector(
    ".complementary-products__container"
  );

  swiper.classList.add("swiper-horizontal-override");

  (swiperWrapper || complementaryProductsContainer).style.transform =
    "translate3d(0px, 0px, 0px)";

  const complementaryProducts = document.querySelector(
    ".product__block--complementary"
  );
  complementaryProducts.classList.add("color-scheme-10");

  const shopButtons = (
    swiper || complementaryProductsContainer
  ).querySelectorAll(".product-card__list-actions a");

  const locale = getLocale();

  const nextButton = swiper.querySelector(".swiper-button-next");
  if (nextButton) {
    setInterval(() => {
      nextButton.click();
    }, 5000);
  }

  shopButtons.forEach((shopButton) => {
    const button = document.createElement("button");
    button.classList.add("color-scheme-inverse");
    button.innerHTML = `<span class="btn__text product__block--complementary__add-to-cart-upsell-button">
      <img src="${window.assets.iconPlus}" class="icon icon--small" alt="" />
      <span class="btn__text">${locale.product.add_to_cart_short}</span>

        <svg
          aria-hidden="true"
          focusable="false"
          class="spinner icon icon--medium loading__spinner hidden"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
          style="stroke: rgb(var(--color-foreground));"
        >
          <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
        </svg>
    </span>`;

    const productId = new URL(shopButton.href).searchParams.get("pr_rec_pid");

    button.addEventListener("click", (e) => {
      e.preventDefault();

      const complementaryProduct = window.complementaryProducts?.find?.(
        (product) => product.id === Number(productId)
      );

      if (complementaryProduct) {
        const formData = {
          items: [
            {
              id: complementaryProduct.variants[0].id,
              quantity: 1,
            },
          ],
        };

        addToCart(formData, button);
      }
    });

    shopButton.replaceWith(button);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const mutationComplementaryObserver = new MutationObserver((_, observer) => {
    const swiper = document.querySelector(".product__block--complementary");

    if (!swiper) {
      return;
    }

    const swiperWrapper = swiper.querySelector(".swiper-wrapper");
    const complementaryProductsContainer = document.querySelector(
      ".complementary-products__container"
    );

    if ((swiper && swiperWrapper) || complementaryProductsContainer) {
      overrideUpsellCarousel();
      observer.disconnect();
    }
  });

  mutationComplementaryObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  watchCartDrawerProductsRecommendation();
});

const watchCartDrawerProductsRecommendation = () => {
  const mutationCartDrawerObserver = new MutationObserver((_, observer) => {
    const cartDrawerProductsRecommendation = document.querySelector(
      ".cart-drawer-products-recommendation"
    );
    const cartDrawerProductsRecommendationSwiperWrapper =
      cartDrawerProductsRecommendation?.querySelector(".swiper-wrapper");

    if (
      cartDrawerProductsRecommendation &&
      cartDrawerProductsRecommendationSwiperWrapper
    ) {
      overrideCartDrawerProductsRecommendation();
      observer.disconnect();
    }
  });

  const cartDrawer = document.querySelector("#CartDrawer");
  
  if (cartDrawer) {
    mutationCartDrawerObserver.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }
};

window.FoxTheme.pubsub.subscribe(
  window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
  watchCartDrawerProductsRecommendation
);
